/**
 * Created by neo on 11.01.21.
 */
import { makeAutoObservable } from 'mobx';
import { ExploreEntry, createExploreEntry } from './ExploreEntry';
import { HttpBackend } from '../../Services/Http/HttpBackend';
import { v1ParamsToV3Params } from './exploreV3Params';
import { ExploreEntryQueryRequest } from './ExploreEntryQueryRequest';
import { PipelineContext, createPipelineContext } from '../Coach/PipelineContext';
import { WorkoutTemplate } from '../Coach/SuperMacro/WorkoutTemplate/WorkoutTemplate';
import { CoachWorkout, CoachWorkoutApi } from '../Coach/Program/Workout/CoachWorkout';

export type WorkoutTemplateEntry = ExploreEntry & {
  type: 'workoutTemplate';
  workoutTemplateId: string;
  context: PipelineContext;
  durationInMinutes: number;
  workoutTemplate?: WorkoutTemplate;
  generate(context?: PipelineContext): Promise<CoachWorkout>;
};

export function createWorkoutTemplateEntry(json?: Partial<WorkoutTemplateEntry>): WorkoutTemplateEntry {
  const base = createExploreEntry({ ...json, type: 'workoutTemplate' });
  return makeAutoObservable({
    ...base,
    type: 'workoutTemplate' as const,
    workoutTemplateId: json?.workoutTemplateId ?? '',
    context: createPipelineContext(json?.context as any),
    durationInMinutes: json?.durationInMinutes ?? 0,
    workoutTemplate: undefined as WorkoutTemplate | undefined,

    generate(context: PipelineContext = createPipelineContext()): Promise<CoachWorkout> {
      return CoachWorkoutApi.generate(this.workoutTemplateId, this.context.merge(context));
    },
  });
}

export const WorkoutTemplateEntryApi = {
  find(request: Omit<ExploreEntryQueryRequest, 'type'>): Promise<WorkoutTemplateEntry[]> {
    return HttpBackend.get(`/coach/explore/v3/entries`, v1ParamsToV3Params({ ...request, type: 'workoutTemplate' })).then((res) =>
      (res ?? []).map((r: any) => createWorkoutTemplateEntry(r)),
    );
  },

  findOne(id: string): Promise<WorkoutTemplateEntry> {
    return HttpBackend.get(`/coach/explore/v3/entries/${id}`).then((res) => createWorkoutTemplateEntry(res));
  },
};
